import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_b_input = _resolveComponent("b-input")!
  const _component_BFieldHint = _resolveComponent("BFieldHint")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_BFieldHint, {
      label: _ctx.$t('secrets.name'),
      hintKey: "secrets.nameHelp"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_b_input, {
          ref: "nameInput",
          modelValue: _ctx.name,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.name) = $event)),
          placeholder: "MY_SECRET",
          required: "",
          maxlength: "100",
          pattern: "[A-Z_][A-Z0-9_]*",
          "validation-message": _ctx.$t('secrets.nameValidationError')
        }, null, 8, ["modelValue", "validation-message"])
      ]),
      _: 1
    }, 8, ["label"]),
    _createVNode(_component_BFieldHint, {
      label: _ctx.$t('secrets.value'),
      hintKey: "secrets.valueHelp"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_b_input, {
          ref: "valueInput",
          modelValue: _ctx.value,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.value) = $event)),
          type: "textarea",
          placeholder: _ctx.$t('secrets.valuePlaceholder'),
          maxlength: "100000",
          rows: _ctx.rows,
          required: ""
        }, null, 8, ["modelValue", "placeholder", "rows"])
      ]),
      _: 1
    }, 8, ["label"])
  ]))
}